
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getIndiJobStatus = async () => {
  return await get<ApiResponse<any[]>>("/indiJobStatus").then((res)=>{
      return res
    })
};

 